const zoneLocalStorageId = () => {
  return Number(localStorage.getItem("zone_id"));
};

export const zoneLocalStorageName = () => {
  return localStorage.getItem("zone_name") || "";
};

export const getDynamicZoneName = (zoneData) => {
  const rawData = zoneData?.data;
  const zoneDetails = Array.isArray(rawData?.data)
    ? rawData.data[0]
    : Array.isArray(rawData)
    ? rawData[0]
    : rawData?.data || rawData;

  return (
    zoneDetails?.zone_name ||
    zoneData?.zone_name ||
    zoneLocalStorageName() ||
    ""
  );
};

export default zoneLocalStorageId;
